export const home = {
  // Hero
  hero: {
    tag: '言語教育インフラ改革コミュニティ',
    titleHighlight: '「教える」',
    titleRest: 'をもっと自由に、',
    titleLine2: 'もっと身近に。',
    subtext:
      'EachTeachは、個人の言語家庭教師が最大限のパフォーマンスを発揮し、教育の質を全員で高め合える環境のコミュニティです。',
    ctaRegister: 'コミュニティに登録する',
    ctaServices: 'サービスを見る',
    scroll: 'SCROLL',
    stats: {
      categories: '対象区分',
      slaExperts: '専門家参加',
      possibilities: '学びの可能性',
    },
  },

  // Philosophy
  philosophy: {
    label: 'Philosophy',
    visionLabel: 'Our Vision',
    visionQuote: 'コミュニティのサポートによる教育インフラの抜本的改革',
    heading: 'EachTeachが目指すもの',
    paragraph1:
      '私たちは、個人の言語家庭教師が「自立した教育者」として持続的に活動できる社会インフラの構築を目指しています。優れた教師が孤立せず、専門知識と経験を互いに共有し合える場を作ることで、言語教育全体の質を底上げしていきます。',
    paragraph2Before:
      'SLA（第二言語習得）の最新研究を実践に活かし、科学的根拠に基づいた指導法を広めることで、教えることの可能性を拡張していく。それが',
    paragraph2Highlight: 'EachTeachのコアバリュー',
    paragraph2After: 'です。',
    values: {
      independence: '自立',
      coCreation: '共創',
      expertise: '専門性',
      evidence: '科学的根拠',
      diversity: '多様性',
    },
  },

  // Course Flow
  courseFlow: {
    label: 'Course Flow',
    heading: 'コースの流れ',
    intro:
      '言語交換から始まり、家庭教師の補助を受けながら、レベルに応じた段階的な学びへと進んでいきます。',
    step1Title: '言語交換',
    step1Desc:
      'まずは言語交換からスタート。学習者同士・教師との交流を通じて、学びの土台と仲間をつくります。',
    step2Title: '家庭教師補助',
    step2Desc:
      '個人家庭教師のサポートを受けながら学習を進めます。専門家のフィードバックで質を担保します。',
    levelCourseTitle: 'レベル別コース',
    levelA: '入門・基礎（A）',
    levelB1: '中級前半（B1）',
    levelB2: '中級後半（B2）',
    levelC: '上級（C）',
    levelNote:
      '現在の習熟度に合わせて A / B1 / B2 / C の各段階へ。レベルチェックで最適なスタート地点を診断します。',
  },

  // CTA Banner
  cta: {
    label: 'Join Us',
    heading: '今すぐコミュニティに参加しませんか？',
    subtext:
      '個人言語家庭教師、教師を目指す方、SLA専門家、すべての方のご参加をお待ちしています。',
    button: 'コミュニティに登録する',
  },
};
